(function () {
  'use strict';

  try {
    if (window.matchMedia('(min-width: 1024px)').matches && 'scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }
  } catch (e) { /* ignore */ }

  function mapEffect(bead) {
    if (bead.effect) return bead.effect;
    return '';
  }

  var ENERGY_BY_HANDLE = {
    'bead-amethyst': 'Intuition & calm',
    'bead-rose-quartz': 'Love & harmony',
    'bead-tiger-eye': 'Courage & focus',
    'bead-lapis-lazuli': 'Wisdom & truth',
    'bead-citrine': 'Abundance & joy',
    'bead-jade': 'Growth & healing',
    'bead-moonstone': 'New beginnings',
    'bead-labradorite': 'Transformation',
    'bead-black-obsidian': 'Protection',
    'bead-carnelian': 'Passion & vitality'
  };

  var REFERENCE_SIZE_MM = 10;
  var SIZE_OPTIONS_MM = [8, 10, 12];
  var DEFAULT_SIZE_MM = 8;
  /** Minimum preview ring ≈ full bracelet with this many typical 8mm beads */
  var MIN_RING_BEAD_COUNT = 18;
  var MIN_RING_BEAD_MM = 8;
  /** Wrist circumference below this (cm) shows "Too Small" */
  var MIN_WRIST_CM = 12.8;

  function normalizeSizeMm(bead) {
    var size = parseInt(bead && bead.sizeMm, 10);
    if (SIZE_OPTIONS_MM.indexOf(size) === -1) {
      return DEFAULT_SIZE_MM;
    }
    return size;
  }

  function moyshopDesignerV3Factory() {
    return {
      loading: true,
      cartLoading: false,
      beads: [],
      selectedBeads: [],
      ringRadius: 200,
      previewScale: 1,
      saveNotice: '',
      orderNotice: '',
      mobileTab: 'preview',
      isMobile: false,
      searchQuery: '',
      activeFilter: 'All',
      filters: ['All', 'Fortune', 'Love', 'Wisdom', 'Wealth', 'Balance', 'Calm', 'Focus', 'Protection'],
      sizeOptions: SIZE_OPTIONS_MM.slice(),
      customVariantId: null,
      basePrice: 0,
      maxBeads: 60,
      moneyFormat: '${{amount}}',

      init: function () {
        if (this._msInitialized) return;
        this._msInitialized = true;

        var cfgEl = document.getElementById('moyshop-builder-config-v3');
        if (cfgEl) {
          try {
            var cfg = JSON.parse(cfgEl.textContent);
            this.customVariantId = cfg.customVariantId || null;
            this.basePrice = 0;
            this.maxBeads = cfg.maxBeads || 60;
            this.moneyFormat = cfg.moneyFormat || this.moneyFormat;
          } catch (e) { /* ignore */ }
        }

        var catalogEl = document.getElementById('moyshop-bead-catalog-v3');
        if (catalogEl) {
          try {
            var raw = JSON.parse(catalogEl.textContent) || [];
            this.beads = raw.map(function (b) {
              b.effect = mapEffect(b);
              b.energy = b.energy || (b.handle && ENERGY_BY_HANDLE[b.handle]) || b.effect;
              // Catalog rows are size-agnostic; buyer picks 8/10/12 when adding.
              delete b.sizeMm;
              return b;
            });
          } catch (e) {
            this.beads = [];
          }
        }

        this.loading = false;
        var self = this;
        this.checkMobile();
        this._onResize = function () {
          self.checkMobile();
          self.updateRingRadius();
        };
        window.addEventListener('resize', this._onResize);
        this._onPageShow = function () {
          self.scrollDesktopBuilderFrame();
        };
        window.addEventListener('pageshow', this._onPageShow);
        this.$nextTick(function () {
          self.updateRingRadius();
          self.restoreSavedDesign();
          self.scrollDesktopBuilderFrame();
        });
      },

      destroy: function () {
        if (this._onResize) window.removeEventListener('resize', this._onResize);
        if (this._onPageShow) window.removeEventListener('pageshow', this._onPageShow);
      },

      /** PC only: jump so preview + right panel fit centered under sticky header. */
      scrollDesktopBuilderFrame: function () {
        if (window.matchMedia('(max-width: 1023px)').matches) return;

        try {
          if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
        } catch (e) { /* ignore */ }

        var root = this.$el;
        if (!root) return;
        var frame = root.querySelector('.moyshop-builder__grid') || root;

        var apply = function () {
          if (window.matchMedia('(max-width: 1023px)').matches) return;

          var headerH = parseFloat(
            getComputedStyle(document.documentElement).getPropertyValue('--header-height')
          ) || 0;
          if (!headerH) {
            var headerEl =
              document.querySelector('sticky-header') ||
              document.querySelector('.section-header');
            if (headerEl) headerH = headerEl.offsetHeight || 0;
          }

          var rect = frame.getBoundingClientRect();
          var elTop = rect.top + (window.pageYOffset || window.scrollY || 0);
          var elH = rect.height;
          if (!elH) return;

          var viewH = window.innerHeight - headerH;
          var y;
          if (elH >= viewH) {
            y = elTop - headerH;
          } else {
            y = elTop - headerH - (viewH - elH) / 2;
          }

          window.scrollTo(0, Math.max(0, Math.round(y)));
        };

        apply();
        requestAnimationFrame(function () {
          apply();
          requestAnimationFrame(apply);
        });
        // Header --header-height / fonts can settle slightly later on refresh.
        setTimeout(apply, 50);
        setTimeout(apply, 200);
      },

      get filteredBeads() {
        var q = (this.searchQuery || '').toLowerCase().trim();
        var filter = this.activeFilter;
        return this.beads.filter(function (b) {
          if (filter !== 'All') {
            if (!b.effect || b.effect !== filter) return false;
          }
          if (!q) return true;
          return (b.name || '').toLowerCase().indexOf(q) !== -1 ||
            (b.energy || '').toLowerCase().indexOf(q) !== -1 ||
            (b.effect || '').toLowerCase().indexOf(q) !== -1;
        });
      },

      get beadsSubtotal() {
        return this.selectedBeads.reduce(function (acc, b) { return acc + b.price; }, 0);
      },

      /** Scheme A: wrist ≈ sum of bead diameters (mm), shown as cm */
      get wristCircumferenceMm() {
        return this.selectedBeads.reduce(function (sum, b) {
          return sum + normalizeSizeMm(b);
        }, 0);
      },

      get wristIsTooSmall() {
        return (this.wristCircumferenceMm / 10) < MIN_WRIST_CM;
      },

      get wristLabel() {
        if (this.wristIsTooSmall) return 'Too Small';
        var cm = this.wristCircumferenceMm / 10;
        return (Math.round(cm * 10) / 10).toFixed(1) + ' cm';
      },

      get groupedBeads() {
        var groups = {};
        this.selectedBeads.forEach(function (b) {
          var sizeMm = normalizeSizeMm(b);
          var key = String(b.id) + '_' + sizeMm;
          if (!groups[key]) {
            groups[key] = {
              groupKey: key,
              id: b.id,
              name: b.name,
              effect: b.effect,
              energy: b.energy,
              image: b.image,
              price: b.price,
              sizeMm: sizeMm,
              qty: 0,
              total: 0
            };
          }
          groups[key].qty += 1;
          groups[key].total += b.price;
        });
        return Object.keys(groups).map(function (key) { return groups[key]; });
      },

      get totalPrice() {
        return this.beadsSubtotal;
      },

      /** PC: cart list fills remaining column height and scrolls. */
      get cartListBoxStyle() {
        if (this.isMobile) return {};
        return {
          flex: '1 1 auto',
          maxHeight: 'none',
          overflowY: 'auto',
          overflowX: 'hidden',
          minHeight: '0'
        };
      },

      get payloadJson() {
        if (!this.selectedBeads.length) return '';
        return JSON.stringify({
          version: 3,
          beads: this.selectedBeads.map(function (b) {
            return { id: b.id, sizeMm: normalizeSizeMm(b) };
          })
        });
      },

      formatMoney: function (amount) {
        var n = Number(amount).toFixed(2);
        return this.moneyFormat.replace(/\{\{\s*amount\s*\}\}/, n).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(amount));
      },

      formatBeadSize: function (sizeMm) {
        return normalizeSizeMm({ sizeMm: sizeMm }) + 'mm';
      },

      beadBasePx: function (bead) {
        var sizeMm = normalizeSizeMm(bead);
        var base = this.isMobile ? 54 : 64;
        return Math.max(24, Math.round(base * (sizeMm / REFERENCE_SIZE_MM)));
      },

      beadPreviewPx: function (bead) {
        return Math.max(10, Math.round(this.beadBasePx(bead) * (this.previewScale || 1)));
      },

      checkMobile: function () {
        this.isMobile = window.matchMedia('(max-width: 1023px)').matches;
      },

      scheduleRingUpdate: function () {
        var self = this;
        if (typeof this.$nextTick === 'function') {
          this.$nextTick(function () {
            self.updateRingRadius();
          });
        } else {
          setTimeout(function () {
            self.updateRingRadius();
          }, 0);
        }
      },

      updateRingRadius: function () {
        var el = this.$refs.ringStage;
        if (!el) return;

        var stageSize = Math.min(el.offsetWidth, el.offsetHeight);
        if (this.isMobile) {
          stageSize = Math.min(stageSize, window.innerWidth - 40, window.innerHeight * 0.5);
        }

        // Floor radius ≈ 18 × 8mm beads packed on a circle (matches a full classic bracelet)
        var refBeadPx = Math.max(24, Math.round((this.isMobile ? 54 : 64) * (MIN_RING_BEAD_MM / REFERENCE_SIZE_MM)));
        var minRadius = (MIN_RING_BEAD_COUNT * refBeadPx) / (2 * Math.PI);

        var beads = this.selectedBeads;
        if (!beads.length) {
          this.previewScale = 1;
          var emptyNeeded = minRadius * 2 + refBeadPx + 24;
          var emptyAvailable = Math.max(120, stageSize * 0.92);
          var emptyScale = emptyNeeded > emptyAvailable ? emptyAvailable / emptyNeeded : 1;
          this.previewScale = emptyScale;
          this.ringRadius = Math.max(36, Math.round(minRadius * emptyScale));
          return;
        }

        // Scheme A: circumference ≈ sum of bead diameters → radius = sum / (2π)
        var totalPx = 0;
        var maxBead = 0;
        for (var i = 0; i < beads.length; i++) {
          var px = this.beadBasePx(beads[i]);
          totalPx += px;
          if (px > maxBead) maxBead = px;
        }

        var idealRadius = Math.max(totalPx / (2 * Math.PI), minRadius);
        var diameterNeeded = idealRadius * 2 + maxBead + 24;
        var available = Math.max(120, stageSize * 0.92);
        var scale = 1;
        if (diameterNeeded > available) {
          scale = available / diameterNeeded;
        }

        this.previewScale = scale;
        this.ringRadius = Math.max(36, Math.round(idealRadius * scale));
      },

      addBead: function (bead, sizeMm) {
        if (this.selectedBeads.length >= this.maxBeads) {
          alert('Maximum ' + this.maxBeads + ' beads per bracelet.');
          return;
        }
        if (sizeMm == null) {
          alert('Choose a size: 8mm, 10mm, or 12mm.');
          return;
        }
        var size = normalizeSizeMm({ sizeMm: sizeMm });
        this.selectedBeads.push(Object.assign({}, bead, {
          sizeMm: size,
          uniqueKey: Date.now() + Math.random()
        }));
        this.saveNotice = '';
        if (!this.wristIsTooSmall) this.orderNotice = '';
        this.scheduleRingUpdate();
      },

      setGroupSize: function (group, sizeMm) {
        var size = normalizeSizeMm({ sizeMm: sizeMm });
        if (!group || size === group.sizeMm) return;
        var id = group.id;
        var fromSize = group.sizeMm;
        this.selectedBeads.forEach(function (b) {
          if (b.id === id && normalizeSizeMm(b) === fromSize) {
            b.sizeMm = size;
          }
        });
        this.saveNotice = '';
        this.scheduleRingUpdate();
      },

      removeGroup: function (group) {
        if (!group) return;
        var id = group.id;
        var size = group.sizeMm;
        this.selectedBeads = this.selectedBeads.filter(function (b) {
          return !(b.id === id && normalizeSizeMm(b) === size);
        });
        this.saveNotice = '';
        this.scheduleRingUpdate();
      },

      removeBead: function (index) {
        this.selectedBeads.splice(index, 1);
        this.saveNotice = '';
        this.scheduleRingUpdate();
      },

      moveBead: function (index, direction) {
        var newIndex = index + direction;
        if (newIndex < 0 || newIndex >= this.selectedBeads.length) return;
        var item = this.selectedBeads.splice(index, 1)[0];
        this.selectedBeads.splice(newIndex, 0, item);
        this.scheduleRingUpdate();
      },

      clearAll: function () {
        if (!this.selectedBeads.length) return;
        if (window.confirm('Clear all beads from this design?')) {
          this.selectedBeads = [];
          this.saveNotice = '';
          this.orderNotice = '';
          this.scheduleRingUpdate();
        }
      },

      getInspiration: function () {
        if (!this.beads.length) return;
        this.selectedBeads = [];
        var pool = this.beads.slice();
        var count = Math.min(8, this.maxBeads, pool.length);
        for (var i = 0; i < count; i++) {
          var idx = Math.floor(Math.random() * pool.length);
          var size = SIZE_OPTIONS_MM[Math.floor(Math.random() * SIZE_OPTIONS_MM.length)];
          this.addBead(pool[idx], size);
        }
      },

      saveDesign: function () {
        if (!this.selectedBeads.length) {
          alert('Your bracelet is empty.');
          return;
        }
        try {
          localStorage.setItem('moyshop_bracelet_design_v3', this.payloadJson);
          this.saveNotice = 'Design saved locally.';
        } catch (e) {
          this.saveNotice = 'Could not save design.';
        }
      },

      restoreSavedDesign: function () {
        try {
          var raw = localStorage.getItem('moyshop_bracelet_design_v3');
          if (!raw) return;
          var data = JSON.parse(raw);
          if (!data || !data.beads || !data.beads.length) return;
          var self = this;
          this.selectedBeads = [];
          data.beads.forEach(function (entry) {
            var id = typeof entry === 'object' && entry ? entry.id : entry;
            var sizeMm = typeof entry === 'object' && entry ? entry.sizeMm : DEFAULT_SIZE_MM;
            var bead = self.beads.find(function (b) { return b.id === id; });
            if (bead) self.addBead(bead, sizeMm);
          });
        } catch (e) { /* ignore */ }
      },

      calculateBeadPosition: function (index) {
        var beads = this.selectedBeads;
        var count = beads.length;
        if (!count) return '';

        // Place centers by arc length proportional to each bead's diameter
        var sizes = [];
        var total = 0;
        for (var i = 0; i < count; i++) {
          var s = this.beadBasePx(beads[i]);
          sizes.push(s);
          total += s;
        }
        var cum = 0;
        for (var j = 0; j < index; j++) cum += sizes[j];
        var mid = cum + sizes[index] / 2;
        var angle = (mid / total) * 360 - 90;
        var radian = angle * (Math.PI / 180);
        var radius = this.ringRadius;
        var x = Math.cos(radian) * radius;
        var y = Math.sin(radian) * radius;
        return 'transform: translate(' + x + 'px, ' + y + 'px);';
      },

      beadRingStyle: function (index, bead) {
        var pos = this.calculateBeadPosition(index);
        var px = this.beadPreviewPx(bead);
        var half = px / 2;
        return pos + ' width:' + px + 'px;height:' + px + 'px;margin-left:-' + half + 'px;margin-top:-' + half + 'px;';
      },

      ringTrackSize: function () {
        return (this.ringRadius * 2 + 80) + 'px';
      },

      showOrderNotice: function (msg) {
        var self = this;
        this.orderNotice = msg;
        if (this._orderNoticeTimer) clearTimeout(this._orderNoticeTimer);
        this._orderNoticeTimer = setTimeout(function () {
          self.orderNotice = '';
          self._orderNoticeTimer = null;
        }, 6000);
      },

      addToBag: function () {
        if (!this.selectedBeads.length) {
          alert('Please add at least one bead before adding to cart.');
          return;
        }
        if (this.wristIsTooSmall) {
          var need = MIN_WRIST_CM - (this.wristCircumferenceMm / 10);
          need = Math.max(0.1, Math.round(need * 10) / 10);
          this.showOrderNotice(
            'Wrist size is too small. Add about ' + need.toFixed(1) + ' cm more beads to reach 12.8 cm.'
          );
          return;
        }
        this.orderNotice = '';
        var self = this;
        self.cartLoading = true;

        var design = this.selectedBeads.map(function (b) {
          return b.name + ' ' + normalizeSizeMm(b) + 'mm';
        }).join(' -> ');
        var grouped = this.groupedBeads.map(function (g) {
          return g.name + ' (' + self.formatBeadSize(g.sizeMm) + ') x' + g.qty + ' @ ' + self.formatMoney(g.price);
        }).join('; ');
        var wristNote = this.wristIsTooSmall
          ? 'Too Small'
          : ((Math.round((this.wristCircumferenceMm / 10) * 10) / 10).toFixed(1) + ' cm');
        var totalBeads = this.selectedBeads.length;
        var totalPrice = Number(this.totalPrice) || 0;
        // Carrier product has $1..$150 variants (qty always 1). Charge ceil(bead total).
        var chargeDollars = Math.max(1, Math.min(150, Math.ceil(totalPrice - 1e-9)));

        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        var jsonHeaders = { 'Content-Type': 'application/json', Accept: 'application/json' };

        function clipProp(value, maxLen) {
          var s = String(value == null ? '' : value);
          if (s.length <= maxLen) return s;
          return s.slice(0, Math.max(0, maxLen - 3)) + '...';
        }

        function nextBraceletNumber(cart) {
          var max = 0;
          (cart.items || []).forEach(function (item) {
            var props = item.properties || {};
            var raw = props['Bracelet #'] || props['Bracelet ID'] || '';
            var m = String(raw).match(/(\d+)/);
            if (m) max = Math.max(max, parseInt(m[1], 10));
          });
          return max + 1;
        }

        function resolveCustomVariantId(dollars) {
          return fetch(root + 'products/custom-bracelet-build.js', { headers: { Accept: 'application/json' } })
            .then(function (r) {
              if (!r.ok) throw new Error('Custom bracelet product missing');
              return r.json();
            })
            .then(function (product) {
              var variants = (product && product.variants) || [];
              var wantCents = dollars * 100;
              var match = null;
              for (var i = 0; i < variants.length; i++) {
                if (Number(variants[i].price) === wantCents) {
                  match = variants[i];
                  break;
                }
              }
              if (!match) {
                // Fallback: nearest at-or-above, else highest
                var sorted = variants.slice().sort(function (a, b) {
                  return Number(a.price) - Number(b.price);
                });
                for (var j = 0; j < sorted.length; j++) {
                  if (Number(sorted[j].price) >= wantCents) {
                    match = sorted[j];
                    break;
                  }
                }
                if (!match) match = sorted[sorted.length - 1];
              }
              if (!match || !match.id) throw new Error('Custom bracelet variant missing');
              return parseInt(match.id, 10);
            });
        }

        Promise.all([
          fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
            if (!r.ok) throw new Error('Cart read error');
            return r.json();
          }),
          resolveCustomVariantId(chargeDollars)
        ])
          .then(function (results) {
            var cart = results[0];
            var variantId = results[1];
            var braceletNum = nextBraceletNumber(cart);
            var braceletLabel = 'Bracelet #' + braceletNum;

            var items = [
              {
                id: variantId,
                quantity: 1,
                properties: {
                  'Bracelet #': String(braceletNum),
                  Wrist: wristNote,
                  'Total beads': String(totalBeads),
                  'Bead total': self.formatMoney(totalPrice),
                  Design: clipProp(design, 240),
                  Beads: clipProp(grouped, 240),
                  _build: 'v3'
                }
              }
            ];

            var noteBlock = [
              '--- ' + braceletLabel + ' ---',
              'Custom Bracelet Design',
              'Design: ' + design,
              'Beads: ' + grouped,
              'Total beads: ' + totalBeads,
              'Wrist: ' + wristNote,
              'Bead total: ' + self.formatMoney(totalPrice),
              'Charged: ' + self.formatMoney(chargeDollars),
              'Note: bead inventory is fulfilled manually from this design list.'
            ].join('\n');
            var prevNote = (cart.note || '').trim();
            var nextNote = prevNote ? prevNote + '\n\n' + noteBlock : noteBlock;

            return fetch(root + 'cart/add.js', {
              method: 'POST',
              headers: jsonHeaders,
              body: JSON.stringify({ items: items })
            })
              .then(function (r) {
                if (!r.ok) throw new Error('Cart error');
                return r.json();
              })
              .then(function () {
                return fetch(root + 'cart/update.js', {
                  method: 'POST',
                  headers: jsonHeaders,
                  body: JSON.stringify({ note: nextNote })
                });
              })
              .then(function (r) {
                if (!r.ok) throw new Error('Cart note error');
                return r.json();
              });
          })
          .then(function () {
            window.location.href = root + 'cart';
          })
          .catch(function (err) {
            console.error(err);
            alert('Could not add to cart. Please try again.');
          })
          .finally(function () {
            self.cartLoading = false;
          });
      }
    };
  }

  window.moyshopDesignerV3 = moyshopDesignerV3Factory;

  document.addEventListener('alpine:init', function () {
    Alpine.data('moyshopDesignerV3', moyshopDesignerV3Factory);
  });
})();
